import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeOrderStatusProps } from '../types/interfaces'

import { OrderStatus } from '@brighterly/lib-core-types/orders/enums'

import { useListsStore } from '@shared/model'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeOrderStatusOptions {
  props: BadgeOrderStatusProps
}

interface BadgeOrderStatusReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

const STATUS_COLORS: Partial<Record<OrderStatus, AppBadgeColor>> = {
  [OrderStatus.CREATED]: 'blue',
  [OrderStatus.PROCESSING]: 'blue',
  [OrderStatus.SUCCEEDED]: 'emerald',
  [OrderStatus.FAILED]: 'red',
  [OrderStatus.REFUNDED]: 'red',
  [OrderStatus.CHARGEBACK]: 'red',
  [OrderStatus.VOIDED]: 'slate',
}

export const useBadgeOrderStatus = ({ props }: BadgeOrderStatusOptions): BadgeOrderStatusReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<OrderStatus>({
    status: () => props.status,
    colors: STATUS_COLORS,
    labels: () => listsStore.getLists?.order.status,
  })
}
